import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_CAB_SCHEDULES}>
			<Outlet />
		</ForbidUnlessAuthorized>
	)
}
